import "./styles.css";
import { mount } from "svelte";
import App from "./App.svelte";
import { meshEnabled } from "./mesh-config";

// Thin mount (utility-redesign plan §7): the playground UI + control flow live in App.svelte,
// which talks to compute only through the `Runner` seam. The static nav lives in index.html;
// the #about / #contribute overlay routes are still rendered by their pure-DOM modules and
// toggle the playground's visibility, unchanged by the framework swap.

// Reveal the Contribute nav link only when a coordinator is configured (mesh enabled).
if (meshEnabled()) {
  const navContribute = document.getElementById("nav-contribute");
  if (navContribute) navContribute.hidden = false;
}

const target = document.getElementById("app");
if (!target) throw new Error("missing #app mount point");

mount(App, { target });
